import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon, HomeIcon } from 'lucide-react';
import { motion } from 'framer-motion';
interface BreadcrumbsProps {
  items: Array<{
    label: string;
    path: string;
  }>;
  className?: string;
  showHomeIcon?: boolean;
}
const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
  items,
  className = '',
  showHomeIcon = true
}) => {
  const itemVariants = {
    hidden: {
      opacity: 0,
      x: -5
    },
    visible: (i: number) => ({
      opacity: 1,
      x: 0,
      transition: {
        delay: i * 0.1,
        duration: 0.3
      }
    })
  };
  return <nav className={`flex items-center text-sm ${className}`} data-id="element-571">
      <ol className="flex items-center flex-wrap" data-id="element-572">
        {items.map((item, index) => <Fragment key={index} data-id="element-573">
            {index === 0 ? <motion.li custom={index} initial="hidden" animate="visible" variants={itemVariants} data-id="element-574">
                <Link to={item.path} className="flex items-center hover:underline transition-colors" data-id="element-575">
                  {showHomeIcon && index === 0 && item.label === 'Home' ? <>
                      <HomeIcon className="h-3.5 w-3.5 mr-1" data-id="element-576" />
                      <span className="sr-only" data-id="element-577">Home</span>
                    </> : <span data-id="element-578">{item.label}</span>}
                </Link>
              </motion.li> : <motion.li className="flex items-center" custom={index} initial="hidden" animate="visible" variants={itemVariants} data-id="element-579">
                <ChevronRightIcon className="h-3.5 w-3.5 mx-2 text-gray-400" data-id="element-580" />
                <Link to={item.path} className="hover:underline transition-colors" data-id="element-581">
                  {item.label}
                </Link>
              </motion.li>}
          </Fragment>)}
      </ol>
    </nav>;
};
export default Breadcrumbs;